/*
  @MG Custom code
  Développeur: Les Mauvais Garçons
  Note: Ce fichier javascript de fait pas parti du thème n'y du plugin Recharge. 
  Il s'agit d'une exetenstion du theme et du plugin afin de permettre une fonctionnalité supplémentaire

  Cas d'utilisation:
  - 1. Aucun item dans le panier
      - a. Afficher un message que le panier est vide.
  - 2. Tous les items dans le panier ne sont pas dans un Bundle Recharge
  - 3. Tous les items dans le panier sont dans un Bundle Recharge
  - 4. Certains items sont dans un bundle et d'autre non. 
    Ce cas d'utilisation se produit quand l'utilisateur revient dans le site et ajout de nouveaux produits au panier. 
*/

// Check if the Recharge pre-checkout section exists on the page
if (document.getElementById('recharge-pre-checkout')) {
  
  let DOM, CART, GLOBAL, RECHARGE;

  // Immediately-invoked async function for bundle setup
  (async () => {
  try {
        // Dom elements variables
        DOM = {
          action: {
            create: safeGet('#createBundle'),
            clear: safeGet('#clearBundle'),
          },
          recharge: {
            wrapper: safeGet('#recharge-pre-checkout'), 
            select: safeGet('#selling_plan_select'),
            loader: safeGet(".loading-state"),
          },
          error: safeGet(".recharge-global-error"),
        }
      
        // Cart variables
        CART = {
          current: window.cartData || await fetchCart(), // Failsafe init cart with fetch if missing in window , 
          lines: {
            without_bundle: [],
            with_bundle: [],
          }
        }

        // Global variables
        GLOBAL = {
          discount: DOM.recharge.wrapper.getAttribute('data-discount'),
          products: {}, // Will hold cart products by item key. 
          selling_groups: {}, // Will hold all selling group of all the product in the cart
          products_plans: {}, // Will hold selling plan by product item key
          shared_plans: [] // Will hold all shared plan accross products
        }
      
        // All Recharge variables
        const product_id = "7193762332752";
        const variant_id = "41222402015312";
        const product_handle = "bundle-box";
        const collection_id = "274266095696";
        RECHARGE = {
          collection_id: collection_id,
          product_id: product_id,
          variant_it: variant_id,
          product_handle: product_handle,
          component_variants: [],
          bundle_data: {
            productId: product_id,
            variantId: variant_id,
            sellingPlan: null, // Will be change be the on select on the page
            handle: product_handle,
          }
        };
      
        window.recharge_debug && console.log('STATE', {
          "Message": "Default configuration initialise on page loaded."
        });

      } catch (error) {
        abortRecharge();
        throw new Error('Critical DOM elements missing. Aborting script.');
        console.error("Une erreur est survenue lors de l'initialisation du module d'abonnement", error);      
      }
      
    if (CART.current.item_count > 0) {
      // Process each cart item
      await Promise.all(
        CART.current.items.map(async (item) => {
          
          // Fetch product details to extract selling plans
          async function getPlanId() {
            const res = await fetch(`/products/${item.handle}.js`);
            const product = await res.json();

            GLOBAL.products[item.variant_id] = product;
            GLOBAL.products_plans[item.variant_id] = [];

            product.selling_plan_groups.forEach((group) => {
              GLOBAL.selling_groups[group.id] = group;
              GLOBAL.products_plans[item.variant_id].push(group.id);
            });

            return product.selling_plan_groups;
          }

          await getPlanId();

          (item.properties._rc_bundle ? CART.lines.with_bundle : CART.lines.without_bundle).push(item.key);

         

          // Add product to bundle component list
          RECHARGE.component_variants.push({
            collectionId: RECHARGE.collection_id,
            externalProductId: item.id,
            externalVariantId: item.variant_id,
            quantity: item.quantity,
            sellingPlan: null,
          });
        })
      );
            
      // Determine shared plan accross all items in cart
      const plans = Object.values(GLOBAL.products_plans);
      if (plans.length > 0) {
        GLOBAL.shared_plans = plans.reduce((acc, curr) => {
          const currSet = new Set(curr);
          return acc.filter(value => currSet.has(value));
        });

        // Populate the select dropdown with shared selling plans
        GLOBAL.shared_plans.forEach((planId) => {
          const option = document.createElement('option');
          option.value = GLOBAL.selling_groups[planId].id;
          option.textContent = GLOBAL.selling_groups[planId].name;
          DOM.recharge.select.appendChild(option);
        });
      }

      window.recharge_debug && console.log('STATE', {
        "Message": "Selling plans by product fetched from shopify ajax api."
      });
      
      if(window.recharge_debug){
         console.log('Configuration', {
           RECHARGE,
           DOM,
           CART,
           GLOBAL
         })
       }
    }
    // Force a page reload if restored from bfcache (e.g. back button)
    window.addEventListener("pageshow", function (event) {
      if (event.persisted) {
        window.location.reload();
      }
    });
  
    DOM.recharge.select.addEventListener('change', () => {
      // Update selected selling plan on dropdown change
      RECHARGE.component_variants.forEach((el) => {
        GLOBAL.products[el.externalVariantId].selling_plan_groups.forEach((group) => {
          if (group.id === DOM.recharge.select.value) {
            RECHARGE.bundle_data.sellingPlan = Number(group.selling_plans[0].id);
            el.sellingPlan = Number(group.selling_plans[0].id);
          }
      });
    });

      // Remove any errors
      DOM.recharge.wrapper.classList.remove('has-errors');
      
      window.recharge_debug && console.log('STATE', {
        "Message": "Selling plans updated",
        "data": RECHARGE.component_variants
      });
      
    });

    // Handle main action buttons
    if(DOM.action.create){
     DOM.action.create.addEventListener('click', function handleClick(event) {
        DOM.action.create.disabled = true;
        createBundle();
    });
   }
    if( DOM.action.clear){
      DOM.action.clear.addEventListener('click', function handleClick(event) {
        DOM.action.clear.disabled = true;
        clearBundle();
      });
  }

    window.recharge_debug && console.log('STATE', {
      "Message": "Setting event listener for the page actions."
    });
  })();


  async function clearBundle() {
    window.recharge_debug && console.log('STATE', {
      "Message": "Start to clear cart before checkout"
    });
    
    try {
      DOM.action.clear.classList.add('is-loading');
      DOM.recharge.wrapper.classList.add('is-loading');
      DOM.recharge.loader.classList.add('is-active');
      
      const bundleItems = CART.current.items.filter(item => item.properties && item.properties._rc_bundle);

      if(bundleItems.length > 0){  
          const items = bundleItems.map(item => {
          const newProps = { ...item.properties };
          delete newProps._rc_bundle;
          delete newProps._rc_bundle_collection_id;
          delete newProps._rc_bundle_parent;
          delete newProps._rc_bundle_variant;
          delete newProps.Rabais;
        
          return {
            id: item.variant_id,
            quantity: item.quantity,
            properties: newProps
          };
        });
        
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });

        
        window.recharge_debug && console.log('STATE', {
          "Message": "Add product cart before checkout and remove old lines"
        });
        DOM.action.clear.classList.add('is-added');
        removeCartLine(CART.lines.with_bundle);

      }else{
        DOM.action.clear.classList.add('is-added');
        console.log('There is no bundle to clear, you can go to checkout');
        // ✅ Only run after all updates
        redirectToCheckout();
      }
    
    } catch (error) {
      
      handleError("Une erreur est survenue lors de la mise à jour du panier. Veuillez réessayer.");
      console.error('Error updating (clearBundle) cart before checkout:', error);      

    }
  }
  // Create and validate the Recharge bundle, then add to cart
  async function createBundle() {

    window.recharge_debug && console.log('STATE', {
      "Message": "Start to create new recharge bundle before checkout"
    });

    try {
      DOM.action.create.classList.add('is-loading');
      DOM.recharge.wrapper.classList.add('is-loading');
      DOM.recharge.loader.classList.add('is-active');
  
      const value = DOM.recharge.select.value;
  
      if (!value) {
        
        DOM.recharge.wrapper.classList.remove('is-loading');
        DOM.recharge.loader.classList.remove('is-active');
        DOM.recharge.wrapper.classList.add('has-errors');
        DOM.action.create.classList.remove('is-loading');
        DOM.action.create.disabled = false;

        window.recharge_debug && console.warn('STATE', {
          "Message": "You must select one selling plan. Selling plan cannot be empty."
        });
        
        return;
      }
  
      const bundle = {
        externalVariantId: RECHARGE.bundle_data.variantId,
        externalProductId: RECHARGE.bundle_data.productId,
        selections: RECHARGE.component_variants,
      };
  
      window.recharge_debug && console.log('STATE', {
          "Message": "Final recharge bundle object created.",
          "data": bundle,
      });
  
      const isValid = await recharge.bundle.validateDynamicBundle(bundle);
  
      if (isValid) {
        const lineItems = await recharge.bundle.getDynamicBundleItems(bundle, RECHARGE.bundle_data.handle);
  
        lineItems.forEach((line) => {
          line.properties.Rabais = `${GLOBAL.discount}% de rabais abonnement`;
        });
  
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: lineItems })
        })
          .then(res => res.json())
          .then((data) => {
            console.log('Added to cart:', data);
            DOM.action.create.classList.add('is-added');
            removeCartLine([...CART.lines.without_bundle, ...CART.lines.with_bundle]);
          })
          .catch(error => {
            DOM.action.create.classList.remove('is-loading');
            console.error('Error adding to cart:', error);
          });
      } else {
        console.warn('Cannot create bundle based on the current selection');
      }
    } catch (error) {
      handleError("Une erreur est survenue lors de la création de votre abonnement. Veuillez réessayer.");
    }
  }

  // Remove given cart line items
  function removeCartLine(lines) {
    if (lines.length === 0) {
      console.log('There are no lines to clear in the cart');
      return;
    }

    const updates = {};
    lines.forEach(line => {
      updates[line] = 0;
    });

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    })
      .then(res => res.json())
      .then(data => {
        console.log('Item(s) removed:', data);
        // Optionally redirect here
        redirectToCheckout();
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }

  // Redirect user to checkout and reset loading state
  function redirectToCheckout() {
    DOM.recharge.wrapper.classList.remove('is-loading');
    DOM.recharge.loader.classList.remove('is-active');
    window.location.href = '/checkout';
  }

  function handleError(errorMessage){
      if(DOM.error){
        DOM.error.classList.add('is-visible');
        DOM.error.textContent = errorMessage;
      }else{
        alert(errorMessage)
      }

      if(DOM.recharge.wrapper && DOM.recharge.loader){
          DOM.recharge.wrapper.classList.remove('is-loading');
          DOM.recharge.loader.classList.remove('is-active');
      }

      setTimeout(() => {
        DOM.error.classList.remove('is-visible');
        DOM.action.clear.disabled = false;
        DOM.action.create.disabled = false;

        DOM.action.create.classList.remove('is-added', 'is-loading');
        DOM.action.clear.classList.remove('is-added', 'is-loading');
      }, 3000)
  }

  function abortRecharge() {
    document.querySelector('.abonnement').classList.add('is-aborded');
    document.querySelector('.recharge-global-error').classList.add('is-visible');
    DOM.action.create.remove();
    DOM.recharge.select.remove();
  }
  async function fetchCart() {
    const res = await fetch('/cart.js');
    const data = await res.json();
    return data;
  }
  
  function safeGet(selector, all = false) {
    const el = all ? document.querySelectorAll(selector) : document.querySelector(selector);
    if (!el || (all && el.length === 0)) {
      console.warn(`[SafeGet] Element not found: ${selector}`);
    }
    return el;
  }
}


document.addEventListener('theme:cart:change', (e) => {
  fetch(theme.routes.cart_url + '?section_id=api-checkout-button')
    .then((response) => response.text())
    .then((response) => {
      const element = document.createElement('div');
      element.innerHTML = response;
      document.querySelector('.cart__buttons__fieldset .checkout-placeholder').innerHTML = response;
    })
    .catch((error) => console.log(error));
});